module.exports = __webpack_public_path__ + "img/bancomat.6a5bf992.png";